<script setup>
import { computed } from 'vue'
import { trim } from 'lodash-es'

const model = defineModel()
const props = defineProps(['options', 'id', 'layout', 'label'])
const _options = computed(() => {
  if (Array.isArray(props.options)) {
    return props.options.map((label, idx) => ({ label, value: idx, key: trim(label) }))
  }

  const opts = []
  for (const [label, value] of Object.entries(props.options)) {
    opts.push({ label, value, key: trim(label) })
  }
  return opts
})
</script>
<template>
  <div class="grid">
    <div class="form-check" v-for="{ label, value, key } of _options" :key="key">
      <input
        class="form-check-input"
        type="radio"
        v-model="model"
        :value="value"
        :id="`${id}:${key}`"
        :checked="value == model"
      />
      <label class="form-check-label" :for="`${id}:${key}`">{{ label }}</label>
    </div>
  </div>
  <slot name="default" />
</template>
